import { render } from "./OrderModalTypeIndicator.vue?vue&type=template&id=15e9c1b6"
import script from "./OrderModalTypeIndicator.vue?vue&type=script&lang=js"
export * from "./OrderModalTypeIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_955269ba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__